export default __webpack_public_path__ + "static/media/Browser.40a94e2c.svg";